module.exports = __webpack_public_path__ + "static/media/15.df7463c6.png";